<template>
  <div class="mod-mobile-register">
    <div class="mod-header">
      <h5 class="main-title">赋能企业数字化转型</h5>
      <p class="sub-title">注册员工账号</p>
    </div>
    <van-form ref="form" class="register-form" @submit="onSubmit">
      <van-field
        v-model.trim="pName"
        maxlength="50"
        placeholder="请输入企业名称"
        :error-message="pNameErrMsg"
        @focus="handlerFocus"
        @blur="(e) => {
          handlerBlur(e)
          checkCompanyName(e)
        }"
      />
      <van-field
        v-model.trim="name"
        maxlength="10"
        placeholder="请输入员工姓名"
        :error-message="nameErrMsg"
        @focus="handlerFocus"
        @blur="(e) => {
          handlerBlur(e)
          checkName(e)
        }"
      />
      <van-field
        v-model.trim="phone"
        maxlength="11"
        placeholder="请输入手机号"
        type="number"
        @focus="handlerFocus"
        @blur="(e) => {
          handlerBlur(e)
          checkPhone(e)
        }"
        :error-message="phoneErrMsg"
      />
      <van-field
        v-model.trim="code"
        type="number"
        maxlength="6"
        placeholder="请输入短信验证码"
        :error-message="codeErrMsg"
        @focus="handlerFocus"
        @blur="(e) =>{
          handlerBlur(e)
          checkPhoneCode(e)
        }"
        @input="() => { codeCheckMsg = '' }"
        class="mod-input-mobile-code-box"
      >
        <template #button>
          <getCode @change="onGetCode" :white-theme="false" />
        </template>
      </van-field>
      <van-button block type="info" native-type="submit" class="m-register-btn" :loading="loading"  loading-text="提交中..." :disabled="!(pName && name && phone && code)">
        提交
      </van-button>
    </van-form>
    <p class="user-tips">
      <span class="sub-tips">已有账号？</span>
      <label class="main-tips" @click="onLogin">直接登录</label>
    </p>
  </div>
</template>

<script>
import getCode from '../m_login/get-code.vue'
import cookie from '@jw/ability-business-components/tools/lib/cookie'
import Api from '@/pc_login/api.js'
import { Toast, Dialog } from 'vant'
import Vue from 'vue'
Vue.use(Dialog)
Vue.use(Toast)
export default {
  data () {
    return {
      pName: null,
      pNameErrMsg: null,
      name: null,
      nameErrMsg: null,
      phone: null,
      phoneErrMsg: null,
      phoneCheckMsg: null,
      code: null,
      codeErrMsg: null,
      codeCheckMsg: null,
      shouldCheckCodeTotal: false,
      loading: false
    }
  },
  components: {
    getCode
  },
  mounted () {
    this.$route.query.partnerId && Api.getPartenerName(this.$route.query.partnerId).then(({ data }) => {
      this.pName = data.partnerName
    }).catch(({ response }) => {
      Api.message(Toast, response)
    })
    this.shouldCheckCodeTotal = (Number(cookie.getCookieUtil('_register_employee_m')) || 0) > 5
  },
  methods: {
    handlerFocus (el) {
      setTimeout(() => {
        if (el.target.scrollIntoView) {
          el.target.scrollIntoView(false)
        } else {
          document.body.scrollTop = document.body.scrollHeight
        }
      }, 100)
    },
    handlerBlur (el) {
      if (!el.target.scrollIntoView) {
        var ua = navigator.userAgent.toLowerCase()
        if (/iphone|ipad|ipod/.test(ua)) {
          var currentPosition
          var speed = 1
          setTimeout(() => {
            currentPosition = document.documentElement.scrollTop || document.body.scrollTop
            currentPosition -= speed
            window.scrollTo(0, currentPosition)
            currentPosition += speed
            window.scrollTo(0, currentPosition)
          }, 1)
        }
      }
    },
    checkCompanyName (e) {
      const callback = typeof e === 'function' ? e : ''
      if (!this.pName) {
        this.pNameErrMsg = '请输入公司名称'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else {
        this.pNameErrMsg = ''
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(true)
      }
    },
    checkName (e) {
      const callback = typeof e === 'function' ? e : ''
      if (!this.name) {
        this.nameErrMsg = '请输入员工姓名'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else {
        this.nameErrMsg = ''
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(true)
      }
    },
    checkPhone (e) {
      const callback = typeof e === 'function' ? e : ''
      if (!this.phone) {
        this.phoneErrMsg = '请输入手机号'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } if (this.phoneCheckMsg) {
        this.phoneErrMsg = this.phoneCheckMsg
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else if (!/^1[0-9]{10}$/.test(this.phone)) {
        this.phoneErrMsg = '请输入正确的手机号码'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else {
        this.phoneErrMsg = ''
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(true)
      }
    },
    checkPhoneCode (e) {
      const callback = typeof e === 'function' ? e : ''
      if (this.shouldCheckCodeTotal) {
        this.codeErrMsg = '操作过于频繁，请休息5分钟再试'
        // eslint-disable-next-line standard/no-callback-literal
        callback && callback(false)
      } else {
        if (!this.code) {
          this.codeErrMsg = '请输入验证码'
          // eslint-disable-next-line standard/no-callback-literal
          callback && callback(false)
        } else if (this.code.length < 6) {
          this.codeErrMsg = '请输入6位数验证码'
          // eslint-disable-next-line standard/no-callback-literal
          callback && callback(false)
        } else if (this.codeCheckMsg) {
          this.codeErrMsg = this.codeCheckMsg
          // eslint-disable-next-line standard/no-callback-literal
          callback && callback(false)
        } else {
          this.codeErrMsg = ''
          // eslint-disable-next-line standard/no-callback-literal
          callback && callback(true)
        }
      }
    },
    onGetCode (done) {
      this.checkPhone((validate) => {
        if (validate) {
          let total = Number(cookie.getCookieUtil('_register_employee_m')) || 0
          if (total === 5) {
            this.shouldCheckCodeTotal = true
            cookie.setCookieUtil('_register_employee_m', 6, new Date(Date.now() + 5 * 60 * 1000))
            setTimeout(() => {
              this.shouldCheckCodeTotal = false
            }, 5 * 60 * 1000)
            this.checkPhoneCode()
          }
          if (total > 5) {
            this.checkPhoneCode()
          }
          if (total < 5) {
            this.checkPhoneCode()
            cookie.setCookieUtil('_register_employee_m', total + 1, new Date(Date.now() + 2 * 60 * 1000))
            Api.postPhoneCode({
              phone: this.phone,
              type: 6,
              isCheckPhone: 2
            }).catch(({ response }) => {
              Api.message(Toast, response)
            })
            done && done()
          }
        }
      })
    },
    onSubmit () {
      this.checkCompanyName((v) => {
        this.checkName((val) => {
          this.checkPhone((valid) => {
            this.checkPhoneCode((result) => {
              if (v && val && valid && result) {
                this.loading = true
                Api.postEmployee({
                  pName: this.pName,
                  phone: this.phone,
                  code: this.code,
                  name: this.name
                }).then(({ data }) => {
                  if (Number(data.result) === 0) {
                    this.$emit('change', 'result')
                  } else {
                    this.$emit('change', 'employeeInfo', data.empRegId)
                  }
                }).catch(({ response }) => {
                  if (response && response.status === 406) {
                    const data = response.data
                    if (data.code === 406001) {
                      this.codeCheckMsg = data.msg
                      this.checkPhoneCode()
                    }
                    if (data.code === 406003) {
                      Dialog.alert({
                        title: '提示',
                        message: '注册失败，当前企业还未注册企业主账号，请确认企业名称是否有误？',
                        confirmButtonText: '重新填写'
                      })
                    }
                    if (data.code === 406004) {
                      Dialog.alert({
                        title: '提示',
                        message: '注册失败，当前手机号已被其他账号使用，请直接登录已有账号。',
                        confirmButtonText: '立即登录'
                      }).then(res => {
                        this.$router.push({
                          path: '/m-auth'
                        })
                      })
                    }
                  } else {
                    Api.message(Toast, response)
                  }
                }).finally(() => {
                  this.loading = false
                })
              }
            })
          })
        })
      })
    },
    onLogin () {
      this.$router.push({ path: '/m-auth' })
    }
  }
}
</script>

<style lang="less">
.mod-mobile-register{
  background-color: #F6F8FB;
  min-height: 100vh;
  text-align: center;
  .mod-header{
    width: 100%;
    height: 205px;
    margin: 0 auto;
    position: relative;
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('/imgs/m_header.png');
    background-color: transparent;
    .main-title{
      font-size: 24px;
      color: #FFFFFF;
      height: 33px;
      line-height: 33px;
      margin: 0 auto;
      padding-top: 40px;
      font-weight: 600;
      text-align: center;
      box-sizing: content-box;
    }
    .sub-title{
      font-size: 15px;
      color: #FFFFFF;
      height: 21px;
      line-height: 21px;
      text-align: center;
      padding-top: 8px;
    }
  }
  .register-form{
    margin: 0px 30px 0;
   .van-field__control {
      color: #333 ;
      background-color: transparent;
      &::placeholder {
        color: #999;
        -webkit-text-fill-color: #999;
      }
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-transition-delay: 99999s;
        -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
        }
    }
    input::placeholder {
        color: #999;
        -webkit-text-fill-color: #999;
      }
    .van-cell {
      background-color: #F6F8FB;
      border-radius: 4px;
      padding: 0;
      &::after{
        border-bottom:none;
      }
      &+.van-cell {
        margin-top: 20px;
      }
      .van-field__control{
        padding: 10px 16px;
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        &:focus, &:active{
          outline: none;
          border-color: #409eff;
        }
      }
      &.img-code-input .van-field__control{
        padding: 0;
        background-color: #F6F8FB;
        padding: 0;
        background-color: #F6F8FB;
        border: none;
        border-radius: 0;
        height: 46px;
        .mod-input-code-box{
          position: relative;
          width: 100%;
          .input-code{
            padding: 10px 16px;
            -webkit-appearance: none;
            background-color: #fff;
            background-image: none;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            box-sizing: border-box;
            width: 220px;
            &:focus, &:active{
              outline: none;
              border-color: #409eff;
            }
          }
          .code-img{
            position: absolute;
            right: 0;
            top: 2px;
            height: 40px;
            width: 100px;
          }
        }
      }
      &.mod-input-mobile-code-box .van-field__button{
        position: absolute;
        top: 4px;
        right: 10px;
        padding: 0;
      }
    }
  }
  .m-register-btn {
    margin: 30px 0px 0;
    border-radius: 6px;
  }
  .user-tips{
    margin-top: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    .sub-tips{
      font-size: 14px;
      color: #999999;
    }
    .main-tips{
      font-size: 14px;
      color: #409EFF;
      &:active{
        color: #1a6dc3;
      }
    }
  }
}
</style>
